/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ChevronDoubleRightIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Chevron Double Right',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M9.61805,16.24512c-.29883-.28711-.3086-.76172-.02051-1.05957l4.98633-5.18359-4.99902-5.19727c-.28808-.29785-.27832-.77246.02051-1.05957.29687-.28711.77246-.27832,1.05957.02051l5.5,5.7168c.28027.29004.28027.74902,0,1.03906l-5.4873,5.70312c-.14649.15332-.34375.23047-.54004.23047-.18751,0-.37501-.06934-.51954-.20996Z"
      fill="currentColor"
    />
    <path
      d="M3.86805,16.24512c-.29883-.28711-.3086-.76172-.02051-1.05957l4.98633-5.18359L3.83485,4.80469c-.28808-.29785-.27832-.77246.02051-1.05957.29687-.28711.77246-.27832,1.05957.02051l5.5,5.7168c.28027.29004.28027.74902,0,1.03906l-5.4873,5.70312c-.14649.15332-.34375.23047-.54004.23047-.18751,0-.37501-.06934-.51954-.20996Z"
      fill="currentColor"
    />
  </svg>`;
};
